const LOAD_DETAIL_TRAINING           = 'LOAD_DETAIL_TRAINING'
const LOAD_DETAIL_TRAINING_SUCCESS   = 'LOAD_DETAIL_TRAINING_SUCCESS'
const LOAD_DETAIL_TRAINING_FAILED    = 'LOAD_DETAIL_TRAINING_FAILED'
const UNMOUNT_DETAIL_TRAINING        = 'UNMOUNT_DETAIL_TRAINING'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const trainingDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_TRAINING:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_TRAINING_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_TRAINING_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_TRAINING:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default trainingDetailReducer;